import { Box, Typography } from '@mui/material';
import { CSSProperties, ReactEventHandler } from 'react';

export const ImageShowcase = ({
    src,
    keyword,
    width = 200,
    highlight = false,
    onLoad,
}: {
    src: string;
    keyword?: string;
    width?: CSSProperties['width'];
    highlight?: boolean;
    onLoad?: ReactEventHandler<HTMLImageElement>;
}) => {
    return (
        <Box
            data-mui-color-scheme='light'
            sx={(theme) => ({
                width: width,
                padding: 1,
                borderRadius: 1,
                backgroundColor: highlight ? (theme.vars || theme).palette.primary.light : (theme.vars || theme).palette.grey[200],
            })}
        >
            <Box
                sx={(theme) => ({
                    p: 1,
                    aspectRatio: 1,
                    borderRadius: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: (theme.vars || theme).palette.grey[100],
                })}
            >
                <Box
                    component='img'
                    alt='image'
                    src={src}
                    sx={{
                        width: '100%',
                        aspectRatio: '1',
                        objectFit: 'contain',
                    }}
                    onLoad={onLoad}
                />
                {keyword && (
                    <Typography variant='h6' color='secondary' textAlign='center' sx={{ mt: 1 }}>
                        {keyword}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};
